var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-end" },
        [
          _c("b-col", { staticClass: "my-1", attrs: { md: "10" } }),
          _c(
            "b-col",
            { attrs: { lg: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "float-right my-1",
                  attrs: { variant: "success" },
                  on: { click: _vm.openAddTaskModal },
                },
                [
                  _c("feather-icon", { attrs: { icon: "PlusIcon" } }),
                  _vm._v("Add Task"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger", size: "sm" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  items: _vm.paginatedTasks,
                  fields: _vm.fields,
                },
                scopedSlots: _vm._u([
                  {
                    key: "head(status)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Status")]),
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.optionStatusFilters,
                                size: "sm",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "status", $$v)
                                },
                                expression: "filters.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(title)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Title")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Search Title",
                                size: "sm",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "title", $$v)
                                },
                                expression: "filters.title",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(description)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Description")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Search Description",
                                size: "sm",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "description", $$v)
                                },
                                expression: "filters.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(salesPerson)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Sales Person")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Search Sales Person",
                                size: "sm",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.salesPerson,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "salesPerson", $$v)
                                },
                                expression: "filters.salesPerson",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(importance)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Tag")]),
                            _c("b-form-select", {
                              attrs: {
                                options: [
                                  { value: null, text: "All" },
                                  { value: true, text: "Important" },
                                  { value: false, text: "Mild" },
                                ],
                                size: "sm",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.importance,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "importance", $$v)
                                },
                                expression: "filters.importance",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(dueDate)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Due Date")]),
                            _c("DatePicker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                range: "",
                                format: "YYYY-MM-DD",
                                placeholder: "Select date range",
                                size: "sm",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.dueDateRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "dueDateRange", $$v)
                                },
                                expression: "filters.dueDateRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(createdOn)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Created On")]),
                            _c("DatePicker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                range: "",
                                format: "YYYY-MM-DD",
                                placeholder: "Select date range",
                                size: "sm",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.createdOnRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "createdOnRange", $$v)
                                },
                                expression: "filters.createdOnRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(title)",
                    fn: function (data) {
                      return [
                        _c("h5", [_vm._v(_vm._s(data.item.title || "-N/A-"))]),
                      ]
                    },
                  },
                  {
                    key: "cell(description)",
                    fn: function (data) {
                      return [
                        _c("h5", [
                          _vm._v(
                            _vm._s(data.item.description || "no description")
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(salesPerson)",
                    fn: function (data) {
                      return [
                        _c("h5", [
                          _vm._v(
                            _vm._s(
                              _vm.getSalePersonName(data.item.salesPersonId) ||
                                "-N/A-"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(dueDate)",
                    fn: function (data) {
                      return [
                        _c("h6", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDate(data.item.dueDate) || "-N/A-"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(importance)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-badge",
                          {
                            staticClass: "d-flex",
                            attrs: { variant: "bg-transparent" },
                          },
                          [
                            _c("feather-icon", {
                              class: [
                                "mr-1 text-" +
                                  _vm.getImportanceVariant(
                                    data.item.isImportant
                                  ),
                              ],
                              attrs: { icon: "CircleIcon", size: "20" },
                            }),
                            _c("h5", [
                              _vm._v(
                                _vm._s(
                                  data.item.isImportant ? "Important" : "Mild"
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(createdOn)",
                    fn: function (data) {
                      return [
                        _c("h6", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDate(data.item.created_On) || "-N/A-"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-dropdown",
                          {
                            attrs: {
                              variant: "link",
                              "toggle-class": "text-decoration-none",
                              "no-caret": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("feather-icon", {
                                        staticClass:
                                          "text-body align-middle mr-25",
                                        attrs: {
                                          icon: "MoreHorizontalIcon",
                                          size: "16",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditModal(data.item)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "EditIcon" },
                                }),
                                _c("span", [_vm._v("View / Edit")]),
                              ],
                              1
                            ),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDelete(data.item)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "Trash2Icon" },
                                }),
                                _c("span", [_vm._v("Delete")]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            [
              _c("b-pagination", {
                attrs: {
                  "per-page": _vm.perPage,
                  "total-rows": _vm.totalRows,
                  align: "center",
                  "aria-controls": "table",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "addTaskModal",
            title: "Add Task",
            centered: "",
            size: "lg",
          },
          on: { ok: _vm.handleAddTask },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    { on: { click: _vm.handleAddTask } },
                    [
                      _vm.loadingAdd
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      !_vm.loadingAdd
                        ? _c("span", [_vm._v("Add Task")])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showAddTaskModal,
            callback: function ($$v) {
              _vm.showAddTaskModal = $$v
            },
            expression: "showAddTaskModal",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Task Title",
                        "label-for": "TaskTitleInput",
                        state: _vm.titleValidation,
                        "invalid-feedback": _vm.titleError,
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "TaskTitleInput", required: "" },
                        on: { change: _vm.validateTitle },
                        model: {
                          value: _vm.title,
                          callback: function ($$v) {
                            _vm.title = $$v
                          },
                          expression: "title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Tag", "label-for": "tagInput" } },
                    [
                      _c("v-select", {
                        attrs: {
                          dir: _vm.$store.state.appConfig.isRTL ? "rtl" : "ltr",
                          options: _vm.optionTags,
                          label: "title",
                        },
                        model: {
                          value: _vm.selectedTag,
                          callback: function ($$v) {
                            _vm.selectedTag = $$v
                          },
                          expression: "selectedTag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Sales Person",
                        "label-for": "salesPersonInput",
                        state: _vm.salespersonValidation,
                        "invalid-feedback": _vm.salespersonError,
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          id: "salesPersonId",
                          options: _vm.optionsSalesPerson,
                          required: "",
                        },
                        on: { input: _vm.validateSalesperson },
                        model: {
                          value: _vm.salesPersonId,
                          callback: function ($$v) {
                            _vm.salesPersonId = $$v
                          },
                          expression: "salesPersonId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Due Date",
                        "label-for": "dueDateInput",
                        state: _vm.dueDateValidation,
                        "invalid-feedback": _vm.dueDateError,
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        staticClass: "mb-1",
                        attrs: { id: "example-purchase", required: "" },
                        on: { input: _vm.validateDueDate },
                        model: {
                          value: _vm.dueDate,
                          callback: function ($$v) {
                            _vm.dueDate = $$v
                          },
                          expression: "dueDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Status", "label-for": "status" } },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.optionStatus },
                        model: {
                          value: _vm.selectedStatus,
                          callback: function ($$v) {
                            _vm.selectedStatus = $$v
                          },
                          expression: "selectedStatus",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Description",
                        "label-for": "editDescription",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: { id: "editDescription" },
                        model: {
                          value: _vm.description,
                          callback: function ($$v) {
                            _vm.description = $$v
                          },
                          expression: "description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "viewModal", title: "View Task", centered: "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showViewModal,
            callback: function ($$v) {
              _vm.showViewModal = $$v
            },
            expression: "showViewModal",
          },
        },
        [
          _c("p", [
            _c("strong", [_vm._v("Task Title: ")]),
            _vm._v(_vm._s(_vm.selectedTask.title)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Sales Person: ")]),
            _vm._v(
              _vm._s(_vm.getSalePersonName(_vm.selectedTask.salesPersonId)) +
                " "
            ),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Description: ")]),
            _vm._v(_vm._s(_vm.selectedTask.description)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Date: ")]),
            _vm._v(_vm._s(_vm.formatDate(_vm.selectedTask.dueDate))),
          ]),
          _c(
            "p",
            [
              _c("strong", [_vm._v("Status: ")]),
              _c(
                "b-badge",
                { staticClass: "d-flex", attrs: { variant: "bg-transparent" } },
                [
                  _c("feather-icon", {
                    class: [
                      "mr-1 text-" +
                        _vm.getImportanceVariant(_vm.selectedTask.isImportant),
                    ],
                    attrs: { icon: "CircleIcon", size: "20" },
                  }),
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.selectedTask.isImportant ? "Important" : "Mild"
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "editTaskModal",
            title: "Add Task",
            centered: "",
            size: "lg",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    { on: { click: _vm.handleEditTask } },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            attrs: { type: "grow", small: "" },
                          })
                        : _vm._e(),
                      !_vm.loading
                        ? _c("span", [_vm._v("Update Task")])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showEditTaskModal,
            callback: function ($$v) {
              _vm.showEditTaskModal = $$v
            },
            expression: "showEditTaskModal",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Task Title",
                        "label-for": "TaskTitleInput",
                        state: _vm.editTitleValidation,
                        "invalid-feedback": _vm.editTitleError,
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "TaskTitleInput", required: "" },
                        on: { change: _vm.validateEditTitle },
                        model: {
                          value: _vm.selectedTask.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedTask, "title", $$v)
                          },
                          expression: "selectedTask.title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Tag", "label-for": "tagInput" } },
                    [
                      _c("v-select", {
                        attrs: {
                          dir: _vm.$store.state.appConfig.isRTL ? "rtl" : "ltr",
                          options: _vm.optionTags,
                          label: "title",
                          clearable: false,
                        },
                        model: {
                          value: _vm.selectedTag,
                          callback: function ($$v) {
                            _vm.selectedTag = $$v
                          },
                          expression: "selectedTag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Sales Person",
                        "label-for": "salesPersonInput",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.optionsSalesPerson },
                        model: {
                          value: _vm.selectedTask.salesPersonId,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedTask, "salesPersonId", $$v)
                          },
                          expression: "selectedTask.salesPersonId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Due Date",
                        "label-for": "dueDateInput",
                        state: _vm.editDueDateValidation,
                        "invalid-feedback": _vm.editDueDateError,
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        staticClass: "mb-1",
                        attrs: { id: "example-purchase", required: "" },
                        on: { blur: _vm.validateEditDueDate },
                        model: {
                          value: _vm.selectedTask.dueDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedTask, "dueDate", $$v)
                          },
                          expression: "selectedTask.dueDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Status", "label-for": "status" } },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.optionStatus },
                        model: {
                          value: _vm.selectedTask.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedTask, "status", $$v)
                          },
                          expression: "selectedTask.status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Comment",
                        "label-for": "editDescription",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: { id: "editDescription" },
                        model: {
                          value: _vm.selectedTask.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedTask, "description", $$v)
                          },
                          expression: "selectedTask.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }